import {Issue} from "common/types/issue";

export function groupContainsDataConsolidationIssue(
  issues: Issue[],
  canViewDataConsolidationIssues: boolean,
) {
  if (canViewDataConsolidationIssues) {
    return false;
  }
  return issues.some(issue => issue.llm_analysis_type === "data_consolidation");
}
